import React, { useState } from 'react'
import { Navbar } from './Navbar'
import { Contact } from './Contact'
import { Mainbody } from './Mainbody'
import { Project } from './Project'
import { Work } from './Work'
import { Cube } from './Cube'


const MainComponent = () => {
    const [loading, setloading] = useState(true)

    return (
        <>
            {
                loading ?
                    <><Cube scale={1} /></> :
                    <></>
            }
            <Navbar />
            <Mainbody setloading={setloading} />
            <Project />
            <Work />
            <Contact />
        </>
    )
}

export default MainComponent